import { ImportacaoService } from './orcamento/orcamento-form/importacao';
import { AuthService } from './guards/auth.service';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  PoMenuItem,
  PoModalComponent,
  PoNavbarIconAction,
} from "@po-ui/ng-components";
import { LoginService } from "./login/login.service";
import { AuthGuard } from "./guards/auth.guard";
import { Subscription } from 'rxjs';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  mostrarMenu: boolean = false;
  tipoUser: boolean;
  private subscriptions: Subscription = new Subscription()

  constructor(
    private loginService: LoginService,
    private authService: AuthService,
    public importacaoService: ImportacaoService,
  ) { }

  @ViewChild(PoModalComponent, { static: true }) poModal: PoModalComponent;
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event) {
    console.log('Botão voltar/avançar do navegador acionado');
    this.importacaoService.finalizarImportacao();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event) {
    console.log('Navegador ou aba sendo fechada');
    this.importacaoService.finalizarImportacao();
  }

  ngOnInit(): void {
    this.authService.initializeAuthState();
    
    // Inscrevendo-se ao observable para receber atualizações do menu
    const subMenu = this.authService.mostrarMenu$.subscribe(value => {
      this.mostrarMenu = value;
    });
    // Inscrevendo-se ao observable para receber atualizações do tipo de usuário
    const subTipo = this.authService.tipoUser$.subscribe(value => {
      this.tipoUser = value;
    });

    this.subscriptions.add(subMenu);
    this.subscriptions.add(subTipo);
    
  }

  ngOnDestroy(): void {
    // Cancelando inscrições para evitar vazamentos de memória
    this.subscriptions.unsubscribe();
    this.importacaoService.finalizarImportacao()
  }

  readonly navActions: Array<PoNavbarIconAction> = [
    {
      icon: "po-icon po-icon-home",
      label: "Dashboard",
      link: "/",
      tooltip: "Dashboard"
    },
    // { icon:'po-icon po-icon-users', label: 'Clientes', link: '/customer-list', tooltip: "Clientes" },
    {
      icon: "po-icon po-icon-cart",
      label: "Orçamentos",
      link: "/orcamento",
      tooltip: "Orçamentos"
    },
    // { icon:'po-icon po-icon-users', label: 'Clientes', link: '/customer-list', tooltip: "Clientes" },
    {
      icon: "po-icon po-icon-users",
      label: "Alterar Senha",
      link: "/passwd",
      tooltip: "Alterar senha",
    },
    {
      icon: "po-icon po-icon-exit",
      label: "Sair",
      action: () => this.sair(),
      tooltip: "Sair"
    }
    // { icon:'po-icon po-icon-gift', label: 'Ex:Tipos Inputs', link: '/nivers', tooltip: "Ex:Tipos Inputs" }
  ];

  // [*MainMenu]
  readonly menus: Array<PoMenuItem> = [
    {
      icon: "po-icon po-icon-home",
      label: "Home",
      link: "/",
      shortLabel: "Home",
    },
    {
      icon: "po-icon po-icon-cart",
      label: "Orçamentos",
      link: "/orcamento",
      shortLabel: "Orçamentos",
    },
    {
      icon: "po-icon po-icon-finance",
      label: "Financeiro",
      link: "/financeiro",
      shortLabel: "Financeiro",
    },
    {
      icon: "po-icon po-icon-settings",
      label: "Área Técnica",
      link: "/areaTecnicacliente",
      shortLabel: "Área Técnica",
    },
    {
      icon: "po-icon po-icon-exit",
      label: "Sair",
      action: () => this.sair(),
      shortLabel: "Sair",
    },
    // { icon:'po-icon po-icon-gift', label: 'Ex:Tipos Inputs', link: '/nivers' }
  ];

  readonly menusA: Array<PoMenuItem> = [
    /*
    {
      icon: "po-icon po-icon-home",
      label: "Dashboard",
      link: "/",
      shortLabel: "Dashboard"
    }, */
    {
      icon: "po-icon po-icon-cart",
      label: "Gestão de Orçamentos",
      link: "/adm_orcamento",
      shortLabel: "Gestão",
    },
    {
      icon: "po-icon po-icon-settings",
      label: "Área Técnica",
      link: "/areaTecnicaAdmin",
      shortLabel: "Área Técnica",
    },
    {
      icon: "po-icon po-icon-exit",
      label: "Sair",
      action: () => this.sair(),
      shortLabel: "Sair",
    },
    // { icon:'po-icon po-icon-gift', label: 'Ex:Tipos Inputs', link: '/nivers' }
  ];

  sair() {
    if (confirm("Deseja sair?")) {
      this.loginService.fazerLogout();
    }
  }

  alterarSenha() {
    this.poModal.open();
  }


  navType(): Array<PoNavbarIconAction> {
    var nav: Array<PoNavbarIconAction> = [
      {
        icon: "po-icon po-icon-home",
        label: "Dashboard",
        link: "/",
        tooltip: "Dashboard",
      },
      ,
      // { icon:'po-icon po-icon-users', label: 'Clientes', link: '/customer-list', tooltip: "Clientes" },
      {
        icon: "po-icon po-icon-users",
        label: "Alterar Senha",
        link: "/passwd",
        tooltip: "Alterar senha",
      },
      {
        icon: "po-icon po-icon-cart",
        label: "Orçamentos",
        link: "/orcamento",
        tooltip: "Orçamentos",
      },
      {
        icon: "po-icon po-icon-exit",
        label: "Sair",
        action: () => this.sair.bind(this),
        tooltip: "Sair",
      },
      // { icon:'po-icon po-icon-gift', label: 'Ex:Tipos Inputs', link: '/nivers', tooltip: "Ex:Tipos Inputs" }
    ];

    return nav;
  }
}
